import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LmsModalFrameComponent } from '@lmsSharedUI';
import { LmsTableWrapperComponent } from '@lmsShared';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-field-loans-report-dialog',
  templateUrl: './field-loans-report.component.html',
  styleUrls: ['./field-loans-report.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    LmsModalFrameComponent,
    LmsTableWrapperComponent
  ],
})
export class FieldLoansReportComponent {
  fieldLoansReportList: any[] = [];
  reportTitle: string = 'Field Loans Report';
  startDate: string = '';
  endDate: string = '';
  fileName = '';

  @ViewChild('TABLE') table: ElementRef;

  config: PaginationInstance = {
    id: 'field-loans-report-pager',
    itemsPerPage: 15,
    currentPage: 1,
  };

  constructor(
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<FieldLoansReportComponent>,
  ) {}

  exportToExcel(): void {
    this.fileName = `FieldLoansReport_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`;
    this.global_utility.startLoading('Exporting data to Excel...');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Field Loans Report');
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to export Excel: ' + err);
      });
  }

  close() {
    this.dialogRef.close();
  }
}